import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import {
  getCurrentUserSession,
  getCurrentUsersRoles,
} from "../../../services/auth/authService";
import loanProductService from "../../../services/creditAssessment/loanProductService";
import LoanProductDetail from "./loanProductDetail";
import EditLoanProduct from "./editLoanProduct";
import { decodeToken } from "react-jwt";
import AddQualificationRuleToProduct from "./addQualificationRulesToLoanProducts";
import { filterList } from "../../../services/utility/textFormatService";
import scoringCardService from "../../../services/creditAssessment/scoringCardService";

export interface LoanProductsProps { }

export interface LoanProductsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  allItems: any;
  showPatchModal: boolean;
  scoreCardList: any;
}

class LoanProductsList extends BaseListComponent<LoanProductsState> { }

class LoanProducts extends React.Component<
  LoanProductsProps,
  LoanProductsState
> {
  _isMounted = false;
  constructor(props: LoanProductsProps) {
    super(props);
    this.state = {
      data: createFilterData([
        "name",
        "productCode",
        "tenure",
      ]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "name", fieldType: "text", value: "" },
        { name: "productCode", fieldType: "text", value: "" },
        { name: "tenure", fieldType: "number", value: "" },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      showPatchModal: false,
      allItems: [],
      scoreCardList: []
    };
  }

  handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    // const decodedToken = decodeToken(getCurrentUserSession().token || "");
    let dataClone = typeof data === "undefined" ? { ...this.state.data } : { ...data };
    try {
      const decodedToken = decodeToken(getCurrentUserSession().token || "");
      const loanProds = await loanProductService.retrieveAllByInstitutionCode(
        decodedToken?.["InstitutionCode"]
      );
      const filteredLPs = filterList(loanProds.data, dataClone);
      // dataClone["institutionId"] = {
      //   item1: "=",
      //   item2: decodedToken?.["InstitutionId"]?.toString() || "",
      // };
      // const loanProducts = await loanProductService.filterPagedLoanProducts(
      //   dataClone,
      //   Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      //   currentPage
      // );
      const loanProducts: any = [];
      const totalLength = filteredLPs.length;
      const initial = (currentPage - 1) * pageSize;
      for (let i = initial; i < initial + pageSize; i++) {
        if (i === totalLength) {
          break;
        }
        loanProducts.push(filteredLPs[i]);
      }

      this.setState({
        tableItems: mapEntityList({
          // entityList: loanProducts.data.item2,
          entityList: loanProducts,
          properties: [
            { oldName: "name", newName: "name" },
            { oldName: "productCode", newName: "productCode" },
            { oldName: "tenure", newName: "tenure" },
          ],
        }),
        currentPage,
        pageSize,
        // totalSize: loanProducts.data.item1,
        totalSize: totalLength,
        fetching: false,
        allItems: filteredLPs,
      });
    } catch (ex) {
      //   console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        this.setState({ fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        this.setState({ fetching: false });
      }
    }
  };

  handleOnExport = async (type: string) => { };

  onTogglePatchModal = () => {
    this.setState({
      showPatchModal: !this.state.showPatchModal,
      showDetailsModal: !this.state.showDetailsModal,
    });
  };

  fetchItemById = async (item: any) => {
    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    this.setState({ fetchingDetail: true });
    let pricing: any = []
    try {
      const pricingDetail = await loanProductService.retrieveProductPricingByInstitutionCode(decodedToken?.["InstitutionCode"], item.productCode)
      pricing = pricingDetail.data
    }
    catch {
      pricing = []
    }
    const loanProduct = await loanProductService.retrieveById(item.id);
    const loanProductList = loanProduct.data
    loanProductList.pricing = pricing ? pricing : []
    this.setState({ item: loanProductList, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    // let scoreCard = await scoringCardService.retrieveScoreCardByInstitutionCode(decodedToken?.["InstitutionCode"])
    // let scoreCardDetails = scoreCard.data
    this.setState({
      // scoreCardList: scoreCardDetails
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    // console.log("asfsdf", this.state.filterValueInput);
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Loan Products</b>
              </h3>
            </div>
            <LoanProductsList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              //   updateState={this.state.updateBaseListState}
              initialValues={{
                data: this.state.data,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
              }) => (
                <Fragment>
                  <LoanProductDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    showTrail={null}
                    currentUserRoles={getCurrentUsersRoles()}
                    item={item}
                    // scoreCardList={this.state.scoreCardList}
                    togglePatchModal={() => {
                      this.onTogglePatchModal();
                      onToggleDetailsModal();
                    }}
                  />
                  <EditLoanProduct
                    showEditModal={showEditModal}
                    toggleEditModal={(reloadDetails: boolean, item: any) => {
                      onToggleEditModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                      this.setState({
                        showDetailsModal: !this.state.showDetailsModal,
                      });
                    }}
                    item={item}
                    scoreCardList={this.state.scoreCardList}
                  />
                  <AddQualificationRuleToProduct
                    showPatchModal={this.state.showPatchModal}
                    togglePatchModal={(reloadDetails: boolean, item: any) => {
                      this.onTogglePatchModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                      onToggleDetailsModal();
                    }}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Loan Products"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></LoanProductsList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default LoanProducts;
